import { defineComponent, toRefs, h } from '@vue/composition-api';
import { withInstall } from '../util/index.js';

var ButtonProps = {
  type: {
    type: String,
    "default": 'default',
    required: false
  },
  icon: {
    type: Object,
    "default": null,
    required: false
  },
  disabled: {
    type: Boolean,
    "default": false,
    required: false
  },
  block: {
    type: Boolean,
    "default": false,
    required: false
  },
  size: {
    type: String,
    "default": 'middle',
    required: false
  },
  shape: {
    type: String,
    "default": 'rect',
    required: false
  }
};
var Button = defineComponent({
  name: 'm-button',
  props: ButtonProps,
  emits: ['click'],
  setup: function setup(props, context) {
    var propsRef = toRefs(props);
    return function () {
      var _context$slots$icon, _context$slots, _context$slots$defaul, _context$slots2;

      var blockClass = propsRef.block.value ? 'm-btn-block' : '';
      var iconVNode = propsRef.icon.value || ((_context$slots$icon = (_context$slots = context.slots).icon) === null || _context$slots$icon === void 0 ? void 0 : _context$slots$icon.call(_context$slots));
      return h("button", {
        "class": "m-btn m-btn-warpper m-btn-type-".concat(propsRef.type.value, " m-btn-size-").concat(propsRef.size.value, " m-btn-shape-").concat(propsRef.shape.value, " ").concat(blockClass),
        "attrs": {
          "disabled": propsRef.disabled.value
        },
        "on": {
          "click": function click(ev) {
            return context.emit('click', ev);
          }
        }
      }, [h("div", {
        "class": "m-btn__text"
      }, [iconVNode && h("div", {
        "class": "m-btn__icon"
      }, [iconVNode]), (_context$slots$defaul = (_context$slots2 = context.slots)["default"]) === null || _context$slots$defaul === void 0 ? void 0 : _context$slots$defaul.call(_context$slots2)])]);
    };
  }
});
withInstall(Button);

export { ButtonProps, Button as default };
//# sourceMappingURL=index.js.map
